export default function ExtensionPrivacy() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#2A332C] px-5 py-16">
      <div className="max-w-2xl mx-auto">
        <a href="/" className="text-sm text-[#3B5A3E] hover:underline">← Back to Shop, Cal & Meal</a>
        <h1 className="mt-6 text-3xl sm:text-4xl font-semibold" style={{ fontFamily: "Outfit, sans-serif" }}>
          Browser Extension — Privacy Policy
        </h1>
        <p className="text-sm text-[#8B9690] mt-2">Last updated: 13 February 2026</p>

        <div className="prose prose-sm max-w-none mt-8 space-y-5 text-[#5C6B61] leading-relaxed">
          <p>
            The Shop, Cal & Meal browser extension is a free companion to <a href="https://smartershop.xyz" className="text-[#3B5A3E] underline">smartershop.xyz</a>. This page explains what it does and doesn&apos;t do with your data.
          </p>

          <h2 className="text-xl font-semibold text-[#2A332C] pt-4" style={{ fontFamily: "Outfit, sans-serif" }}>What we collect</h2>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>Your Shop, Cal & Meal account token</strong> — stored locally in <code>chrome.storage.local</code>. Never synced, never shared.</li>
            <li><strong>The URL of recipe pages you ask us to save</strong> — sent to our parser endpoint only when you tap &ldquo;Save recipe&rdquo;.</li>
            <li><strong>Your basket items</strong> — fetched from your Shop, Cal & Meal account so the extension knows what to add to your supermarket cart.</li>
            <li><strong>Aggregated &ldquo;out of stock&rdquo; signals</strong> — when an item fails at a supermarket, we log <em>(store, item name)</em> to suggest substitutes next time. No personal data attached.</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#2A332C] pt-4" style={{ fontFamily: "Outfit, sans-serif" }}>What we DON&apos;T do</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>No keystroke logging on supermarket pages.</li>
            <li>No reading or transmitting of your supermarket account credentials.</li>
            <li>No third-party trackers or ad networks.</li>
            <li>No selling or sharing of your data with anyone.</li>
            <li>No reading of unrelated browser tabs.</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#2A332C] pt-4" style={{ fontFamily: "Outfit, sans-serif" }}>Permissions explained</h2>
          <ul className="list-disc list-inside space-y-1">
            <li><strong>activeTab</strong> — read the URL of the recipe page when you click &ldquo;Save recipe&rdquo;.</li>
            <li><strong>tabs, scripting</strong> — open a tab per basket item & inject the per-supermarket auto-add script.</li>
            <li><strong>storage</strong> — remember your backend URL + auth token between sessions.</li>
            <li><strong>Host permissions</strong> on the 6 UK supermarket domains only — required to click the &ldquo;Add to basket&rdquo; button. We don&apos;t look at anything else on those pages.</li>
          </ul>

          <h2 className="text-xl font-semibold text-[#2A332C] pt-4" style={{ fontFamily: "Outfit, sans-serif" }}>Data retention</h2>
          <p>
            Your token and basket data live in your Shop, Cal & Meal account. To delete everything, go to <strong>Profile → Delete account</strong> on smartershop.xyz — that wipes the database within 24 hours per GDPR.
          </p>

          <h2 className="text-xl font-semibold text-[#2A332C] pt-4" style={{ fontFamily: "Outfit, sans-serif" }}>Source code</h2>
          <p>The extension is open source — read the actual code at <a className="text-[#3B5A3E] underline" href="https://smartershop.xyz/api/extension/download">smartershop.xyz/api/extension/download</a>.</p>

          <h2 className="text-xl font-semibold text-[#2A332C] pt-4" style={{ fontFamily: "Outfit, sans-serif" }}>Contact</h2>
          <p>
            Privacy questions? Email <a className="text-[#3B5A3E] underline" href="mailto:hello@smartershop.xyz">hello@smartershop.xyz</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
